import { render, staticRenderFns } from "./ShopSection.vue?vue&type=template&id=2065eec3&scoped=true"
import script from "./ShopSection.vue?vue&type=script&lang=js"
export * from "./ShopSection.vue?vue&type=script&lang=js"
import style0 from "./ShopSection.vue?vue&type=style&index=0&id=2065eec3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065eec3",
  null
  
)

export default component.exports